module.exports = __webpack_public_path__ + "media/images/common/visit_reserve/kv-phone-213bdebb594de3fb848f880427783614.png";